import { createPageDefinition } from 'ui-page-helpers/src/createPageDefinition';
import { ResetPasswordPage } from './ResetPasswordPage';

export default createPageDefinition({
  title: 'Authentication/Reset Password',
  exportTitle: 'resetPasswordPage',
  selectorClass: 'reset-password-page-embed',
  component: ResetPasswordPage
})